import { CiCreditCard1 } from "react-icons/ci"

// ==============================|| SUBSCRIPTION MENU ||============================== //

const subscription = {
  id: 'subscription',
  title: '',
  type: 'group',
  children: [
    {
      id: 'subscription-management',
      title: 'Subscription',
      type: 'item',
      url: '/subscription',
      icon: CiCreditCard1,
      allowedRoles: ['admin', 'superAdmin', 'financeManager', 'complianceOfficer'],
      breadcrumbs: false
    }
  ]
};

export default subscription;
